import React from 'react';
import IconButton from '@material-ui/core/IconButton';
import { useStyles, styles } from '../KuCatalogueScreenStyles';
import { Icon, Table, Tooltip } from 'antd';
import { useSelector, useDispatch } from 'react-redux';
import { employeeById } from 'app/reducers';
import { KUCatalogueReducer } from 'app/reducers/KUCatalogueReducer';
import * as KUCatalogueActions from 'app/actions/KUCatalogueActions'
import { string } from 'prop-types';

const TableScreen = (props) => {
    let { dtsize } = props;
    const classes = useStyles();
    const dispatch = useDispatch();
    const { siteId } = useSelector(state => state.Auth)

    const employeeData = useSelector(employeeById);

    const { listAllKeyUser,
        isLoadingAllKeyUser,
        pagination
    } = useSelector(state => state.KUCatalogueReducer)

    const dataSource = listAllKeyUser?.map(
        (record, dataIndex) => {
            return {
                'key': dataIndex,
                'name': record.name,
                'idEmployee': record.idEmployee,
                'keyUser': record.idKeyUser,
                'active': record.active,
            }
        }
    );


    const handleTableChange = (pagination, filters, sorter) => {
        let obj = {
            current: pagination.current,
            pageSize: pagination.pageSize,
            total: pagination.total,
            column: Object.keys(sorter).length > 0 ? sorter.field : undefined,
            order: Object.keys(sorter).length > 0 ? (sorter.order === "ascend" ? 'ASC' : 'DESC') : undefined
        }
        dispatch(KUCatalogueActions.savePagination(obj));


        dispatch(KUCatalogueActions.getKeyUsers({
            offset: (pagination.current - 1) * pagination.pageSize,
            limit: pagination.pageSize,
            sortColumn: Object.keys(sorter).length > 0 ? sorter.field : undefined,
            sortDir: Object.keys(sorter).length > 0 ? (sorter.order === "ascend" ? 'ASC' : 'DESC') : undefined,
            Name: "",
            IdEmployee: "",
        }));
    }

    const paginationTable =
    {
        defaultCurrent: 1,
        defaultPageSize: 25,
        current: pagination.current,
        pageSize: pagination.pageSize,
        total: pagination.total,
        showSizeChanger: true,
        pageSizeOptions: ['25', '50', '100'],
        showTotal: (total, range) => `${range[0]}-${range[1]} de ${total} registros`
    }

    const convertDate = (date) => {
        let fechas = date.split("T");
        let dias = fechas[0].split("-");
        return `${dias[2]}-${dias[1]}-${dias[0]}`
    }

    const columns = [
        {
            title: 'Nombre',
            dataIndex: 'name',
            key: 'name',
            sorter: true,
            ellipsis: true,
            width: 250

        },
        {
            title: 'Activo',
            dataIndex: 'active',
            key: 'active',
            sorter: true,
            ellipsis: true,
            width: 300,
            render: (text, record) => (
                <div>
                    {
                        text === 1 ? <b  style={{ color: '#008000'}}>Si</b> : <b style={{ color: '#FF0000'}}>No</b>
                    }
                </div>
            )

        },
        {
            title: 'Acciones',
            key: 'action',
            dataIndex: 'key',
            fixed: 'right',
            width: 120,
            render: (text, record) => (
                <div className={classes.buttons}>
                    {
                        siteId === 'HUB' ?
                            <Tooltip placement="bottomLeft" title={'Eliminar'}>
                                <IconButton className={classes.deleteIcon} onClick={() => props.openDelete(record)} >
                                    <Icon type="delete" />
                                </IconButton>
                            </Tooltip>
                            :
                            null
                    }
                </div>
            )
        }

    ];

    return (
        <div>
            <Table
                loading={isLoadingAllKeyUser}
                columns={columns}
                dataSource={dataSource}
                pagination={paginationTable}
                scroll={dtsize}
                size={"small"}
                onChange={handleTableChange}
            />
        </div>
    )
}

export default TableScreen;
